import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class ProductDetailsSection extends Component {
  #eventTarget;

  connectedCallback() {
    super.connectedCallback();
    this.#eventTarget = this.closest('[id*="ProductInformation-"], featured-product-information, dialog');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#eventTarget = null;
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ variant, detail }) => {
        if (detail?.newProduct) {
          this.dataset.productId = String(detail.newProduct.id);
        } else if (detail?.productId && String(detail.productId) !== this.dataset.productId) {
          return;
        }

        const resource = detail?.resource || {};
        const selectedOptions = variant?.selectedOptions || [
          { value: resource.option1 },
          { value: resource.option2 },
          { value: resource.option3 },
        ];

        this.querySelectorAll('[data-variant-detail-row]').forEach((row) => {
          const source = row.dataset.variantSource;
          let value = '';

          if (source === 'sku') value = resource.sku || '';
          if (source === 'weight') value = this.#formatWeight(resource);
          if (source?.startsWith('option_')) {
            const optionIndex = Number(source.slice(-1)) - 1;
            value = selectedOptions[optionIndex]?.value || '';
          }

          if (!value) value = row.dataset.variantFallback || '';

          const valueElement = row.querySelector('[data-variant-detail-value]');
          if (valueElement) valueElement.textContent = value;
          row.hidden = !value;
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[product-details-section] Event promise rejected:', error);
        }
      });
  };

  #formatWeight(resource) {
    if (resource.weight_with_unit) return resource.weight_with_unit;
    if (typeof resource.weight !== 'number' || resource.weight <= 0) return '';

    const unit = resource.weight_unit || 'g';
    const divisors = { g: 1, kg: 1000, oz: 28.349523125, lb: 453.59237 };
    const value = resource.weight / (divisors[unit] || 1);
    const locale = document.documentElement.lang || 'en';

    return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value)} ${unit}`;
  }
}

if (!customElements.get('product-details-section')) {
  customElements.define('product-details-section', ProductDetailsSection);
}
